export default __webpack_public_path__ + "static/media/imagotipo-vertical-servidor-virtual.c9fad796.svg";